import { Environment as Env } from './develop.environment';

export class Environment extends Env {
  static override readonly urlAPI: string = 'https://adw-dev-am3.azurewebsites.net/';
  static override readonly urlAPIReward: string = 'https://adw-rewards-dev.azurewebsites.net/';
  // static override readonly urlAPI: string = 'https://aws-dev-wag-api-am3.azurewebsites.net/';
  // static override readonly urlAPIReward: string = 'https://aws-dev-rewards.azurewebsites.net/';
}
